export default __webpack_public_path__ + "static/PROUD_xl-a959220326268287fa3f90cf3f760a42.webp";